export default __webpack_public_path__ + "static/adrienne-rio-resume-3d46e0a719d0832517eacc75cdf91ce5.pdf";